import Url from 'domurl';
import {createBrowserHistory} from 'history';

require('jQuery.serializeObject');
const history = createBrowserHistory();

/*
 * XHR instances
 *
 * Note: only one picker is supported per page,
 * if more are needed these XHR variable should be
 * associated with their respective pickers
 */
let pickerXhr;
let receiptXhr;

/**
 * Load a proposition picker for a specific provider
 * @param {jQuery} $container The container to load picker in
 * @param {String} providerId The provider to load picker for
 * @param {String} [productId] The product ID to load picker for
 * @param {Object|String} [selected] Any picked values or a proposition ID that should be active
 */
const loadPropositionPicker = ($container, providerId = undefined, productId = undefined, selected = undefined) => {
    // Fetch defaults from previously loaded picker
    providerId = providerId || $container.data('picker-provider-id');
    productId  = productId || $container.data('picker-product-id');
    if (!providerId) {
        throw new Error('Cannot load picker without provider ID');
    }

    if (pickerXhr != null) {
        pickerXhr.abort();
    }
    if (receiptXhr != null) {
        receiptXhr.abort();
    }

    const $receiptContainer = $($container.data('receipt'));

    $container.addClass('loading').find(':focus').blur();
    $receiptContainer.addClass('loading');

    pickerXhr = $.ajax({
        url:        window.app.urls.propositionPickerView,
        type:       'POST',
        data:       {
            provider_id: providerId,
            product_id:  productId,
            state:       typeof selected === 'object' ? selected : null,
            proposition: typeof selected === 'string' ? selected : null,
        },
        beforeSend: function(xhr) {
            $(`.js-proposition-picker-provider[data-provider-id]`).removeClass('active').addClass('disabled');
        }
    }).done((data) => {
        $container
            .data('picker-provider-id', providerId)
            .data('picker-product-id', productId);

        $container.html(data);
        $(`.js-proposition-picker-provider[data-provider-id]`).removeClass('disabled');
        $(`.js-proposition-picker-provider[data-provider-id="${providerId}"]`).addClass('active');
        window.app.loadComponentsFor($container);

        if ($receiptContainer.length > 0) {
            const id = $container.find('[data-proposition-picked-id]').data('proposition-picked-id');
            if (id.length > 0) {
                loadPropositionReceipt($receiptContainer, id);

                // Edit the URL query param
                if ($container.data('query-param')) {
                    let domUrl                                   = new Url;
                    domUrl.query[$container.data('query-param')] = id;
                    history.push(domUrl.toString());
                }
            } else {
                $receiptContainer.removeClass('loading').html($('#propositionNotfoundAlert').html());
            }
        }

    }).always(() => {
        $container.removeClass('loading');
    }).fail((xhr) => {
        if (xhr.statusText === 'abort') {
            return;
        }

        $container
            .data('picker-provider-id', undefined)
            .data('picker-product-id', undefined);

        if ($receiptContainer.length > 0) {
            $receiptContainer.removeClass('loading').html($('#propositionNotfoundAlert').html());
        }
    });
};

/**
 * Load a receipt for a proposition in the given container
 * @param {jQuery} $container
 * @param {string} propositionId
 */
const loadPropositionReceipt = ($container, propositionId) => {
    if (receiptXhr != null) {
        receiptXhr.abort();
    }
    $container.addClass('loading');
    receiptXhr = $.ajax({
        url: `${window.app.urls.propositionPickerReceipt}/${propositionId}`,
    }).done((data) => {
        $container.html(data);
        window.app.loadComponentsFor($container);
    }).always(() => {
        $container.removeClass('loading');
    });
}

/**
 * Handle changes of a hardware credit range control
 * @param {jQuery} $control
 */
const onHardwareCreditControlInput = ($control) => {
    const $container     = $control.closest('.js-proposition-picker-hardware-credit');
    const $available     = $('.js-available', $container).show();
    const $unavailable   = $('.js-unavailable', $container).hide();
    const $priceOnce     = $('.js-price-once', $container);
    const $priceMonthly  = $('.js-price-monthly', $container);
    const $bundleIdInput = $(':input[type="hidden"][name]', $container).val('');
    const prices         = $container.data('prices');
    const value          = Number.parseFloat($control.val());

    const formatter = new Intl.NumberFormat($('html').attr('lang').replace('_', '-') || 'nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    $priceMonthly.text(formatter.format(value));

    let isAvailable = false;
    prices.forEach(p => {
        if (p.hasOwnProperty('monthly') && p.monthly === value) {
            isAvailable = true;
            $priceOnce.text(formatter.format(p.once));
            $bundleIdInput.val(p.id);
        }
    });
    if (!isAvailable) {
        $available.hide();
        $unavailable.show();
        // TODO disable receipt?
    }
}

/**
 * Handle changes of a control within a picker
 * @param {jQuery} $control
 */
const onControlChange = ($control) => {
    const $container = $control.closest('.js-proposition-picker');

    // Collect all input values up until and including the changed input,
    // the remainder will be determined by the composer
    let values = $('form', $container).serializeObject();
    values['Bundle']?.forEach((v, k) => {
        if (v) {
            values[`Bundle.${k}`] = v;
        }
    });
    delete values['Bundle'];
    for (const [key, value] of Object.entries(values)) {
        let r = key.match(/^Bundle\[(\d+)\]/);
        if (Array.isArray(r)) {
            values[`Bundle.${r[1]}`] = value;
            delete values[key];
        }
    }

    let seenControl = false;
    for (const key in values) {
        if (seenControl) {
            delete values[key];
            continue;
        }
        if (key === $control.attr('name')) {
            seenControl = true;
        }
    }

    loadPropositionPicker($container, undefined, undefined, values);
}

export default ($container) => {
    $('.js-proposition-picker-provider', $container).on('click', function() {
        const providerId    = $(this).data('provider-id');
        const productId     = $(this).data('product-id');
        const propositionId = $(this).data('proposition-id');
        loadPropositionPicker($($(this).data('target')), providerId, productId, propositionId);
    });

    $('.js-proposition-picker-hardware-credit :input[type="range"]', $container)
        .on('input', function() {
            onHardwareCreditControlInput($(this));
        })
        .on('change', function() {
            $(this)
                .closest('.js-proposition-picker-hardware-credit')
                .find(':input[type="hidden"][name]')
                .trigger('change');
        });

    $.containerOrSelf('.js-proposition-picker :input[name]', $container).on('change', function() {
        onControlChange($(this));
    });

    // Initial load of first available provider or configured proposition ID
    if ($container.is('body')) {
        const $selectedProvider = $('.js-proposition-picker-provider[data-proposition-id]', $container);
        if ($selectedProvider.length > 0) {
            $selectedProvider
                .trigger('click')
                .data('proposition-id', undefined);
        } else {
            $('.js-proposition-picker-provider', $container)
                .first()
                .trigger('click');
        }
    }
}
